<template>
  <div class="app-container">
    <div class="cert-card card flex-1 flex row-center col-center">
      <!--没有审核状态说明，该数据为江招推送 或 多主体前的未认证数据；提示认证-->
      <div v-if="auditStatus === ''" class="flex flex-col">
        <img
          src="@/assets/images/home/no-cert.png"
          style="width: 160px"
          alt=""
        />
        <div class="m-t-24 font-20">
          当前企业未认证，请前往认证
        </div>
        <el-button
          type="primary"
          class="m-t-24"
          style="width: 120px"
          @click="toCertification"
        >
          立即认证
        </el-button>
      </div>

      <!--审核中状态-->
      <div
        v-if="auditStatus === companyCertifiedDict.PENDING.value"
        class="flex flex-col"
      >
        <i class="iconfont icon-time-circle-fill text-warning"></i>
        <div class="font-20 font-bold m-t-20">
          <span class="text-warning">审核中...</span>
          您提交的认证资料会在
          <span class="text-warning">1</span>
          个工作日完成审核
        </div>
      </div>

      <!--审核不通过状态-->
      <div
        v-else-if="auditStatus === companyCertifiedDict.REJECT.value"
        class="flex flex-col"
      >
        <i class="iconfont icon-close text-danger"></i>
        <div class="font-20 font-bold m-t-16">审核不通过</div>
        <div class="reject-box m-t-12">
          不通过理由：
          <span class="text-info">{{ reasonText }}</span>
        </div>
        <el-button
          type="primary"
          class="m-t-20"
          style="width: 120px"
          @click="toLoginPlatform"
        >修改提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// api接口
import { getCompanyAuditInfoApi } from '@/api/company'

// 数据字典
import { companyCertifiedDict } from '@/dictionary/company'

// 工具函数
import { mapState } from 'vuex'

export default {
  name: 'EnterpriseCertStatus',

  props: {
    // 是否是在企业管理页面中使用
    isEnterprisePage: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      // 数据字典
      companyCertifiedDict,

      // 审核信息
      auditStatus: '',
      reasonText: ''
    }
  },

  computed: {
    ...mapState('company', ['isThirdSyncData'])
  },

  created() {
    this.getCompanyCertificateStatus()
  },

  methods: {
    // 认证未通过前往登录平台的认证页面
    toLoginPlatform() {
      window.location.href = `${process.env.VUE_APP_PASSPORT_URL}/cert/form`
    },

    // 江招推送数据、多主体前遗留数据；前往认证
    toCertification() {
      window.location.href = this.isThirdSyncData
        ? `${process.env.VUE_APP_PASSPORT_URL}/cert/form`
        : `${process.env.VUE_APP_PASSPORT_URL}/cert/select`
    },

    // 获取企业认证的审核状态
    getCompanyCertificateStatus() {
      getCompanyAuditInfoApi()
        .then(res => {
          // 当获取不到审核单的情况下，说明该公司没有认证（江招推送数据，多主体前的企业留存数据），强制跳转到认证页面
          if (!res?.data) return

          this.auditStatus = res?.data?.status
          this.reasonText = res?.data?.auditInfo?.rejectMsg || ''
        })
        .catch(err => {
          this.$message.error(err?.message || '获取主体认证状态失败')
        })
    }
  }
}
</script>

<style scoped lang="scss">
.cert-card {
  width: 1200px;
  margin: auto;

  i {
    font-size: 64px;
    line-height: 1;
  }

  .reject-box {
    max-width: 640px;
    line-height: 22px;
  }
}
</style>
